import React, { useState, useEffect } from 'react';
import '../css/Navbar.css';
import { ReactComponent as Logo } from '../assets/chunks-logo.svg';
import { FaEnvelope, FaLinkedinIn, FaCopy, FaCheck, FaHome, FaInfo } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import NavbarButton from './Navbar-button';

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true); // Track navbar visibility
  const [lastScrollY, setLastScrollY] = useState(0); // Track last scroll position
  const [tooltipContent, setTooltipContent] = useState(null); // Tooltip content

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Hide navbar if scrolling down and past 100px, show if scrolling up
      setIsVisible(currentScrollY <= 100 || currentScrollY < lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText('paulovitorfb@gmail.com'); // Copy to clipboard

    // Show confirmation tooltip
    setTooltipContent(
      <div>
        Email copied! <FaCheck style={{ color: 'green', paddingLeft: '4px' }} />
      </div>
    );

    // Reset tooltip content after 2 seconds
    setTimeout(() => {
      setTooltipContent(
        <div style={{ color: 'var(--button-label-tertiary-active)' }}>
          paulovitorfb@gmail.com <FaCopy style={{ color: 'var(--button-label-tertiary-active)', paddingLeft: '4px' }} />
        </div>
      );
    }, 2000);
  };

  return (
    <nav className={`navbar ${isVisible ? '' : 'hidden'}`}>
      <div className="logo">
        <NavLink to="/">
          <Logo />
        </NavLink>
      </div>
      
      <NavbarButton label="Wholesale"  to="/" />
      <NavbarButton label="Cakes" to="/cakes" />
    </nav>
  );
};

export default Navbar;
